import type { PropsWithChildren } from "react";
import type { Props } from "./DocumentCollectionsPageContext";
import { DocumentCollectionsPageContext } from "./DocumentCollectionsPageContext";

export const DocumentCollectionsPageContextProvider = ({ children, ...contextValue }: PropsWithChildren<Props>) => (
  <DocumentCollectionsPageContext value={contextValue}>{children}</DocumentCollectionsPageContext>
);
